function getSearchParam(param: string) {
    const match = RegExp(`[?&]${param}=([^&]*)`).exec(window.location.search);

    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getGclidCookie() {
    const gclid_cookie = document.cookie.split('; ').find((row) => row.startsWith('ninox-gclid='));

    return gclid_cookie && gclid_cookie.split('=')[1];
}

function setGclidCookie(gclid) {
    const expireTime = 90 * 24 * 60 * 60 * 1000;
    const expiryDate = new Date();
    const time = expiryDate.getTime() + expireTime;

    expiryDate.setTime(time);

    const domain = window.location.hostname === 'localhost' ? 'localhost' : '.ninox.com';

    document.cookie = `ninox-gclid=${gclid}; Domain=${domain}; Expires=${expiryDate.toUTCString()}; SameSite=None; Secure; Path=/`;

    return gclid;
}

export function retrieveGclidField() {
    const gclidParam = getSearchParam('gclid');
    const gclsrcParam = getSearchParam('gclsrc');
    const isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;

    if (gclidParam && isGclsrcValid) {
        setGclidCookie(gclidParam);

        return gclidParam;
    }

    return getGclidCookie();
}
